var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.import_bank_account") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "m-0 pb-3" },
            [
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { staticClass: "pt-2 font-weight-bold", attrs: { xl: "2" } },
                [
                  _c(
                    "label",
                    { staticClass: "color-var-actionTextColorBlack-important" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.slct_file")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { xl: "5" } }, [
                _c("input", {
                  ref: "fileInput",
                  staticClass: "form-control",
                  attrs: { type: "file", name: "file2", id: "file2" },
                  on: { change: _vm.onFileChange },
                }),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { xl: "2", cols: "3" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-135px-important",
                      attrs: { variant: "primary" },
                      on: { click: _vm.importAttachment },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("bank_accounts.imprt")) + " "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }